import { getENVPath } from 'helper';
import ReCAPTCHA from 'react-google-recaptcha';
import { CaptchaContainer, CaptchaError } from './styled';

type RecaptchaFieldProps = {
  onChange: (_token: string | null) => void;
  errorMessage: string;
};

export const GoogleRecaptcha = (props: RecaptchaFieldProps) => {
  const { onChange, errorMessage } = props;
  return (
    <>
      <CaptchaContainer>
        <ReCAPTCHA
          sitekey={getENVPath().NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
          onChange={onChange}
          theme="light"
        />
        {errorMessage && (
          <CaptchaError id="captcha-error-message">{errorMessage}</CaptchaError>
        )}
      </CaptchaContainer>
    </>
  );
};

GoogleRecaptcha.displayName = 'GoogleRecaptcha';
